import { Slot } from '@radix-ui/react-slot';
import type { ButtonHTMLAttributes } from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  asChild?: boolean;
  variant?: 'primary' | 'primary-white' | 'progress' | 'secondary';
};

export function Button({
  asChild = false,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const styles = {
    primary:
      'bg-brand font-semibold text-brand-foreground hover:bg-brand-strong hover:text-brand-strong-foreground',
    'primary-white': 'bg-brand font-semibold text-white hover:shadow-md',
    progress: 'bg-progress font-semibold text-white enabled:hover:shadow-md',
    secondary: 'border border-gray-300 bg-white font-medium text-ink hover:bg-gray-50',
  }[variant];
  const disabledStyles =
    variant === 'progress' ? 'disabled:bg-gray-100 disabled:text-gray-400' : 'disabled:opacity-40';
  const classes = `inline-flex min-h-11 min-w-28 items-center justify-center rounded-md px-5 py-2 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand disabled:cursor-not-allowed ${disabledStyles} ${styles} ${className}`;
  if (asChild) {
    return <Slot className={classes} {...props} />;
  }
  return <button type="button" className={classes} {...props} />;
}
